import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from "recharts";
import "../../containers/SpAndSuAnalysis/style.css";
import { FaChartPie } from "react-icons/fa";
import TextField from "../CommonComponents/TextField";

const { Text, Title } = Typography;

const COLORS = ["#A27EF9", "#54ff29", "#7DE2E0"];

const CommissionChart = ({ platformAmount, expertAmount, platformCommissionPercentage, expertCommissionPercentage, transactionFeesAmount, transactionFeesPercentage }) => {

    const data = [
        {
            name: `Platform Commission (${platformCommissionPercentage.toFixed(0)}%)`,
            value: platformAmount,
        },
        {
            name: `Transactions Fees (${transactionFeesPercentage.toFixed(0)}%)`,
            value: transactionFeesAmount,
        },
        {
            name: `Expert Payouts (${expertCommissionPercentage.toFixed(0)}%)`,
            value: expertAmount,
        },
    ];

    return (
        <Card className="commission-card">
            <div className="chart-container">
                {
                    // platformCommissionPercentage == 0 && expertCommissionPercentage == 0 
                    // ?
                    //     <p style={{ textAlign: 'center' }}>No data Available</p>
                    //     :
                    <ResponsiveContainer>
                        <PieChart>
                            <Pie
                                data={data}
                                dataKey="value"
                                innerRadius={60}
                                outerRadius={90}
                                paddingAngle={2}
                                labelLine={false}
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                ))}
                            </Pie>
                            <Legend
                                layout="vertical"
                                verticalAlign="bottom"
                                align="center"
                                iconType="circle"
                                formatter={(value) => (
                                    <Text className="legend-text">{value}</Text>
                                )}
                            />
                            <Tooltip formatter={(val) => `£${val.toLocaleString()}`} />
                        </PieChart>
                    </ResponsiveContainer>
                }
            </div>

            <Row gutter={8} justify="center" className="stats-row">
                <Col span={8} className="stats-col">
                    <Card className="stats-card platform-card">
                        <Text strong className="stats-label platform-text">Platform</Text>
                        <Title level={4} className="stats-value platform-text">
                            £{platformAmount.toLocaleString()}
                        </Title>
                    </Card>
                </Col>
                <Col span={8} className="stats-col">
                    <Card className="stats-card transaction-card">
                        <Text strong className="stats-label transaction-text">
                            <span className="stats-label-word">Transactions</span>
                            <br />
                            Fees
                        </Text>
                        <Title level={4} className="stats-value transaction-text">
                            £{transactionFeesAmount.toLocaleString()}
                        </Title>
                    </Card>
                </Col>
                <Col span={8} className="stats-col">
                    <Card className="stats-card experts-card">
                        <Text strong className="stats-label experts-text">Experts</Text>
                        <Title level={4} className="stats-value experts-text">
                            £{expertAmount.toLocaleString()}
                        </Title>
                    </Card>
                </Col>
            </Row>
        </Card>

    );
};

export default CommissionChart;
